import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { ApiNamespaces } from '~/constants/env';
import { isDev } from '~/utils/env';

// Clé API pour ajouter les traductions manquantes en dev
const API_KEY = globalThis.VITE_TRANSLATE_KEY;
const apiKey = isDev() ? `Bearer ${API_KEY}` : '';

const detection = {
    order: ['querystring', 'path', 'localStorage', 'navigator'],
    lookupLocalStorage: 'i18nextLng',
    lookupQuerystring: 'lng',
    lookupFromPathIndex: 0,
    checkWhitelist: true,
};

i18n.use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        debug: false,
        detection,
        fallbackLng: 'fr',
        supportedLngs: ['fr', 'en'],
        interpolation: {
            escapeValue: false,
        },
        // Pas de cache localStorage : les traductions sont toujours rechargées depuis l'API
        backend: {
            referenceLng: 'fr',
            loadPath: `${ApiNamespaces.compte}/v1/{{lng}}/listeTraduction?systeme=APPRO`,
            addPath: `${ApiNamespaces.compte}/v1/{{lng}}/ajoutTraductions?systeme=APPRO`,
            crossDomain: true,
            customHeaders: {
                authorization: apiKey,
            },
        },
        saveMissing: isDev(),
    });

export default i18n;
